import { rem, rgba } from 'polished';
import styled, { css } from 'styled-components';

import { IStyledNavMenuListItemProps } from './NavMenu.types';

export const StyledNavMenu = styled.nav`
  width: 100%;
  margin-top: ${rem('40px')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    padding: 0;
    margin-top: ${rem('16px')};
  }
`;

export const StyledNavMenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${rem('2px')};
`;

export const StyledNavMenuListItem = styled.li<IStyledNavMenuListItemProps>`
  padding: ${rem('8px')} ${rem('16px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
  border-radius: ${rem('4px')};
  font-weight: 700;
  transition: all 0.3s;
  text-transform: uppercase;
  list-style: none;

  @media (hover: hover) {
    &:hover {
      color: ${({ theme, user }) => theme.colors[user!].main};
    }
  }

  ${({ isActive, theme, user }) =>
    isActive &&
    css`
      background-color: ${theme.colors[user!].mainPale};
      color: ${theme.colors[user!].main};
    `}
`;

export const StyledNavMenuListItemButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
  color: inherit;
  text-transform: inherit;

  width: 100%;
  height: 100%;
  padding: 0;
  text-align: left;
`;

export const StyledNavMenuListItemLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: block;
`;

export const StyledHelpCard = styled.article`
  background-color: ${({ theme }) => theme.colors.landlord.main};
  width: 100%;
  margin-top: ${rem('40px')};
  border-radius: ${rem('8px')};
  padding: ${rem('16px')};
  color: ${({ theme }) => theme.colors.main};
  display: flex;
  flex-direction: column;
  gap: ${rem('8px')};
`;

export const StyledHelpCardTop = styled.div`
  display: flex;
  gap: ${rem('16px')};
  align-items: center;
`;

export const StyledHelpCardBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('8px')};
  font-size: ${rem('14px')};
`;

export const StyledHelpCardDivider = styled.hr`
  width: 100%;
  height: 1px;
  border: none;
  background-color: ${({ theme }) => rgba(theme.colors.main, 0.5)};
`;

export const StyledHelpCardImage = styled.div`
  display: grid;
  place-items: center;
  & svg {
    height: auto;
    width: ${rem('36px')};

    path {
      fill: ${({ theme }) => theme.colors.main};
    }
  }
`;

export const StyledHelpCardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${rem('2px')};
`;

export const StyledHelpCardTitle = styled.h2`
  font-size: ${rem('16px')};
  font-weight: 700;
  margin: 0;
`;

export const SupportLink = styled.a`
  text-decoration: none;
  color: inherit;
  font-size: ${rem('14px')};
  margin: 0;

  &:hover {
    text-decoration: underline;
  }
`;
